import { MorningBrief } from '../components/brief';

export function Dashboard() {
  return <MorningBrief />;
}
